import * as React from 'react';

import { FormResponseError } from '../../components/cirium/FormResponseError';
import { CiriumCard } from '../../components/cards/CiriumCard';
import { HoneypotInput } from '../../components/forms/HoneypotInput';
import styles from './travelerLoginCard.module.css';

import {
  Box,
  Button,
  Flex,
  Form,
  Link,
  PasswordField,
  TextField,
  TextInput,
} from '@flightstats/airframe-react';

interface TravelerLoginFormValues {
  username: string;
  password: string;
  kwijybo: string;
}

interface FormErrors {
  [key: string]: string;
}

interface TravelerLoginCardProps {
  handleLogin: (errors: FormErrors, values: TravelerLoginFormValues) => void;
  loading: boolean;
  errorMessage?: string;
  brandingImageUrl?: string | null;
}

export const TravelerLoginCard: React.FC<TravelerLoginCardProps> = ({
  handleLogin,
  loading,
  errorMessage,
  brandingImageUrl,
}) => {
  return (
    <CiriumCard
      brandingImageUrl={brandingImageUrl}
      title="Welcome"
      description="Log into Trip Alert with the user information entered during the registration process"
    >
      <Form
        onSubmit={(errors : FormErrors, values : TravelerLoginFormValues, e : any) => {
          e.event.preventDefault(); // Needed for submitOnEnter
          handleLogin(errors, values);
        }}
        submitOnEnter
      >
        {errorMessage && (
          <FormResponseError message={errorMessage} />
        )}
        <TextField required>
          
            <TextInput
              autoFocus
              id="username"
              label="Username"
              placeholder="Enter your username"
              disabled={loading}
            />
          
        </TextField>

        <PasswordField
          required
          validate={() => {
            true;
          }}
        >
          
            <TextInput
              id="password"
              label="Password"
              placeholder="Enter your password"
              type="password"
              disabled={loading}
            />
          
        </PasswordField>

        <HoneypotInput />

        <Box className={styles.paddingBottom}>
          <Link href={loading ? '' : '/traveler/forgot'}>Forgot Login</Link>
        </Box>

        <Flex className={styles.flexColumnCenter}>
          <Button type="submit" disabled={loading}>
            LOG IN
          </Button>
        </Flex>
      </Form>
    </CiriumCard>
  );
};